import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import classNames from 'classnames';
import { useMessage } from '@tmapy/intl';
import { actionSetLayerOpacity, actionSetLayerVisibility } from '@tmapy/mapcore';
import { OpacitySlider, Popup, SIZE, SvgMore, TertiaryBtn, usePopup } from '@tmapy/style-guide';
import './MapSwitcherItem.scss';
import { mapSwitcherMessages } from './mapSwitcherMessages';
export const MapSwitcherItem = ({ layer, layers, dispatch }) => {
    const formatMessage = useMessage();
    const popupTriggerRef = useRef(null);
    const popupContentRef = useRef(null);
    const [isPopupShown, setPopupShown] = usePopup(popupTriggerRef, popupContentRef);
    const { layerId, exclusiveLayerIds } = layer;
    const mapLayer = layers.find((mapLayer) => mapLayer.id === layer.layerId);
    const opacity = mapLayer?.layerOptions.opacity;
    const handleCheckboxChange = useCallback((e) => {
        const value = e.target.checked;
        const layerId = e.target.name;
        const visibilityLayers = { [layerId]: value };
        if (value) {
            if (exclusiveLayerIds) {
                exclusiveLayerIds.forEach((exclusiveLayerId) => (visibilityLayers[exclusiveLayerId] = false));
            }
            if (!opacity) {
                dispatch(actionSetLayerOpacity({ [layerId]: 1 }));
            }
        }
        dispatch(actionSetLayerVisibility(visibilityLayers));
    }, [dispatch, exclusiveLayerIds, opacity]);
    const handleOpacitySliderChange = useCallback((e, eventData) => {
        const opacity = eventData.value;
        const visibilityLayers = { [layerId]: !!opacity };
        if (opacity && exclusiveLayerIds) {
            exclusiveLayerIds.forEach((exclusiveLayerId) => (visibilityLayers[exclusiveLayerId] = false));
        }
        dispatch(actionSetLayerOpacity({ [layerId]: opacity }));
        dispatch(actionSetLayerVisibility(visibilityLayers));
    }, [dispatch, layerId, exclusiveLayerIds]);
    const handleMoreBtnClick = () => {
        setPopupShown(!isPopupShown);
    };
    const layerTitle = formatMessage.fallback([`layer.${layer.layerId}`]) ?? layer.layerId;
    if (!mapLayer) {
        console.warn(`MapSwitcher item "${layerId}" wasn't found in "layers" config`);
        return null;
    }
    return (_jsxs("label", { ref: popupTriggerRef, className: classNames({
            'msw-item': true,
            'msw-item-isCkecked': mapLayer.layerOptions.visible,
        }), children: [_jsx("input", { className: 'msw-item--checkbox', type: 'checkbox', name: layer.layerId, checked: mapLayer.layerOptions.visible, onChange: handleCheckboxChange }), _jsx("img", { alt: layerTitle, src: layer.image }), _jsx("span", { className: 'msw-item--label', children: layerTitle }), layer.isOpacitySliderVisible && (_jsxs(_Fragment, { children: [_jsx("div", { className: 'msw-item--moreBtn', children: _jsx(TertiaryBtn, { icon: { element: _jsx(SvgMore, {}) }, size: SIZE.SML, isActive: isPopupShown, tooltip: formatMessage(mapSwitcherMessages.opacitySlider), onClick: handleMoreBtnClick }) }), isPopupShown && (_jsx(Popup, { position: ['top-center', 'top-left', 'top-right'], triggerRef: popupTriggerRef, children: _jsxs("div", { ref: popupContentRef, className: 'msw-item--slider', children: [_jsx("div", { className: 'sg-a-f-a', children: _jsx(OpacitySlider, { value: opacity ?? 1, showValue: false, onChange: handleOpacitySliderChange }) }), _jsxs("output", { children: [Math.floor((opacity ?? 1) * 100), " %"] })] }) }))] }))] }));
};
//# sourceMappingURL=MapSwitcherItem.js.map